import { render } from "./tradeResult.vue?vue&type=template&id=0c91bf6e"
import script from "./tradeResult.vue?vue&type=script&lang=js"
export * from "./tradeResult.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__